export enum HalfRowLayoutVariant {
  reverse = "reverse",
  mobileReverse = "mobileReverse",
  alternating = "alternating",
}
